import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';

import useConst from '#client/hooks/useConst';

export default function useConstBusinessEntityUuid() {
  const { businessEntityUuid, loading, entitlements } = useBusinessEntity();
  const businessEntityUuidConst = useConst(businessEntityUuid);

  return { businessEntityUuid: businessEntityUuidConst, loading, entitlements };
}
